export default [
  {
    reducerKey: 'faq',
    sagaKey: 'faqSaga',
    importReducer: () => import(/* webpackChunkName: "domain-faq" */ 'modules/Faq/store/reducer'),
    importSaga: () => import(/* webpackChunkName: "domain-faq" */ 'modules/Faq/store/saga'),
  },
]
